import React from 'react';

import Time from '../Time';

import S from './Headline.module.css';

const Headline = ({ isLocked }) => (
  <div className={S.root}>
    <div className={S.net} />
    <div className={S.netTitle}>Vasyl</div>
    <div className={S.wifi}>
      <div className={S.hack} />
    </div>
    <div className={S.time} data-is-locked={isLocked.toString()}>
      <Time />
    </div>
    <div className={S.lock} data-is-locked={isLocked.toString()} />
    <div className={S.battery} />
  </div>
);

export default Headline;
